import axiosInstance from '../utils/axiosConfig';
import { CURRENCY_OPTIONS, INCOTERMS_OPTIONS } from '../utils/constants';
import keepServerAnswer from '../utils/keepServerAnswer';
// Phase 3: Removed personioService import - using HMS APIs directly

/**
 * Service for handling trade recap-related API calls
 */

/**
 * Fetches all dropdown options for trade recap forms from the backend
 * Reuses employee data from Personio API
 *
 * Row 128: a failed staff-list load comes back as the empty lists PLUS
 * `staffListFailed: true` (and `staffListError`, the server's answer kept), so
 * the recap's Deal Maker pickers can say the list couldn't load instead of
 * reading as "there are no traders". A load that succeeds has
 * `staffListFailed: false`, even when a list is genuinely empty.
 */
export const fetchTradeRecapDropdowns = async () => {
  try {
    // Initialize dropdownData object
    const dropdownData = {
      traders: [],
      all_employees: [],
      staffListFailed: false
    };
    
    // Try to fetch HMS employee categories (traders, all_employees)
    try {
      const hmsResponse = await axiosInstance.get('/api/hms-categories/');
      console.log('Received HMS categories for trade recap:', hmsResponse.data);
      
      // Use HMS data if available
      if (hmsResponse.data.success) {
        if (hmsResponse.data.traders && hmsResponse.data.traders.length > 0) {
          dropdownData.traders = hmsResponse.data.traders;
          console.log(`Loaded ${dropdownData.traders.length} traders for trade recap from HMS API`);
        }
        
        // Use all_employees data from HMS if available
        if (hmsResponse.data.all_employees && hmsResponse.data.all_employees.length > 0) {
          dropdownData.all_employees = hmsResponse.data.all_employees;
          console.log(`Loaded ${dropdownData.all_employees.length} employees for trade recap from HMS API`);
        }
      }
    } catch (hmsError) {
      console.error('Error fetching HMS categories for trade recap:', hmsError);
      dropdownData.staffListFailed = true;
      dropdownData.staffListError = keepServerAnswer(hmsError, "Couldn't load the list of staff.");
    }
    
    return dropdownData;
  } catch (error) {
    console.error('Error fetching trade recap dropdowns:', error);
    // Return empty arrays as fallback -- flagged, so it never reads as "none"
    return {
      traders: [],
      all_employees: [],
      staffListFailed: true,
      staffListError: keepServerAnswer(error, "Couldn't load the list of staff.")
    };
  }
};

/**
 * Get relationship graph data for a deal
 */
export const getDealRelationships = async (dealId) => {
  try {
    const response = await axiosInstance.get(`/api/offer/user-offers/${dealId}/get_relationships/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching deal relationships:', error);
    throw error;
  }
};

/**
 * Get relationship graph data for a recap
 */
export const getRecapRelationships = async (recapId) => {
  try {
    const response = await axiosInstance.get(`/api/offer/trade-recaps/${recapId}/get_relationships/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching recap relationships:', error);
    throw error;
  }
};

/**
 * Get relationship graph data for a freight recap
 */
export const getFreightRecapRelationships = async (recapId) => {
  try {
    const response = await axiosInstance.get(`/api/offer/freight-recaps/${recapId}/get_relationships/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching freight recap relationships:', error);
    throw error;
  }
};

// Export all services
const tradeRecapService = {
  fetchTradeRecapDropdowns,
  getDealRelationships,
  getRecapRelationships,
  getFreightRecapRelationships
};

export default tradeRecapService; 